"use client";

import { DateTime, IANAZone } from "luxon";
import { useEffect, useState } from "react";
import { cn } from "~/utils/fontsConfig";

export const EventTimezone = (props: { timezone: string; startTime: Date }) => {
    const [timezone, setTimezone] = useState(props.timezone);

    useEffect(() => {
        const tzLocalNotation = new IANAZone(props.timezone).offsetName(
            props.startTime.getTime() || new Date().getTime(),
            { format: "short" },
        );
        tzLocalNotation && setTimezone(tzLocalNotation);
    }, [props.timezone, props.startTime]);
    return <span>{timezone}</span>;
};

export const TimeDisplay = ({
    startTime,
    endTime,
    eventTimezone,
    className,
}: {
    startTime: Date;
    endTime: Date | null;
    eventTimezone: string;
    className?: string;
}) => {
    const [showLocal, setShowLocal] = useState(false);
    const eventStartTime = DateTime.fromJSDate(startTime, {
        zone: "UTC",
    }).setZone(eventTimezone, { keepLocalTime: true });

    const eventEndTime = endTime
        ? DateTime.fromJSDate(endTime, { zone: "UTC" }).setZone(eventTimezone, {
              keepLocalTime: true,
          })
        : null;

    const userZone = DateTime.local().zoneName;
    const userStartTime = eventStartTime.setZone(userZone);
    const userEndTime = eventEndTime?.setZone(userZone) ?? null;

    useEffect(() => {
        setShowLocal(eventTimezone !== userZone);
    }, [eventTimezone, userZone]);

    return (
        <div className={cn("flex flex-col gap-1", className)}>
            <span className={cn(className)}>
                {eventStartTime.toFormat("h:mm a")}
                {endTime && (
                    <> - {eventEndTime && eventEndTime.toFormat("h:mm a")}</>
                )}{" "}
                <EventTimezone
                    timezone={eventTimezone}
                    startTime={eventStartTime.toJSDate()}
                />
            </span>

            {showLocal && (
                <span className="text-sm text-v3-N-400">
                    ({userStartTime.toFormat("h:mm a")}
                    {userEndTime && (
                        <> - {userEndTime.toFormat("h:mm a")}</>
                    )}{" "}
                    <EventTimezone
                        timezone={userZone}
                        startTime={userStartTime.toJSDate()}
                    />
                    )
                </span>
            )}
        </div>
    );
};
